export const CONTACT_PERSON_EMAIL = 'giacomo.habermas@empion.io';
export const CONTACT_PERSON_NAME = 'Giacomo Habermas';
export const CONTACT_PERSON_POSITION = 'Customer Success Manager';

export const SATISFACTION_QUESTION_LABELS = [
  {
    key: 'work_satisfaction',
    title: {
      en: 'I am satisfied with my work',
      de: 'Ich bin zufrieden mit meiner Arbeit',
    },
  },
  {
    key: 'salary_satisfaction',
    title: {
      en: 'I am paid fairly for my work',
      de: 'Ich werde für meine Arbeit angemessen bezahlt',
    },
  },
  {
    key: 'fullfillment_satisfaction',
    title: {
      en: 'My work is fulfilling for me',
      de: 'Meine Arbeit ist für mich erfüllend',
    },
  },
  {
    key: 'values_identification',
    title: {
      en: 'I identify with the values and goals of my employer',
      de: 'Ich identifiziere mich mit den Werten und Zielen meines Arbeitgebers',
    },
  },
  {
    key: 'employer_appreciation',
    title: {
      en: 'I receive appreciation for my work',
      de: 'Ich erhalte Wertschätzung für meine Arbeit',
    },
  },
  {
    key: 'work_conditions',
    title: {
      en: 'I have all the tools I need to do my job well',
      de: 'Ich habe alle Arbeitsmittel, die ich für meinen Job benötige',
    },
  },
  {
    key: 'abilities_satisfaction',
    title: {
      en: 'I can achieve my goals through my abilities',
      de: 'Ich kann durch meine Fähigkeiten meine Ziele erreichen',
    },
  },
  {
    key: 'employer_expectations',
    title: {
      en: 'I know what is expected of me',
      de: 'Mir ist klar, was von mir erwartet wird',
    },
  },
  {
    key: 'leadership_satisfaction',
    title: {
      en: 'I am satisfied with my manager',
      de: 'Ich bin mit meiner Führungskraft zufrieden',
    },
  },
];
